import {
  ICaptureEvnetUUID,
  IEventMissions,
  IMission,
  IMissionEventRandomItem,
  MissionType,
} from '@model';

import { api } from '.';

export const fetchMissionEvent = async () => {
  const { data } = await api.get<IEventMissions>(`/mission-event/`);
  return data;
};

export const postMissionComplete = async (type: MissionType) => {
  const { data } = await api.post<IMission>(`/mission-event/complete/`, {
    type,
  });
  return data;
};

export const postMissionRandomItems = async () => {
  const { data } = await api.post<IMissionEventRandomItem>(
    `/mission-event/random-items/`
  );
  return data;
};

export const postCaptureCharacterId = async (id: number) => {
  const { data } = await api.post<ICaptureEvnetUUID>(
    `/play/chat-capture-share/`,
    {
      character_id: id,
    }
  );
  return data;
};

export const postCaptureUUID = async (uuid: string) => {
  const { data } = await api.post<ICaptureEvnetUUID>(
    `/play/chat-capture-share/${uuid}/`
  );
  return data;
};
